<template>
  <div v-if="isLoading">
    <sgdf-spinner></sgdf-spinner>
  </div>
  <div v-else class="p-4 mx-auto overflow-auto h-full flex-column space-y-4">
    <div class="space-y-4">
      <sgdf-heading>{{ $t("title.meetings.my") }}</sgdf-heading>
      <sgdf-meeting-table
        :meetings="data?.results.filter(isOpenMeeting)"
        @sgdf-meeting-table:click="onSelectMeeting"
      ></sgdf-meeting-table>
    </div>
    <div class="space-y-4">
      <sgdf-heading>{{ $t("title.meetings.my-past") }}</sgdf-heading>
      <sgdf-meeting-table
        :meetings="data?.results.filter(isNotOpenMeeting)"
        @sgdf-meeting-table:click="onSelectMeeting"
      ></sgdf-meeting-table>
    </div>
  </div>
</template>

<script lang="ts" setup>
import "@sgdf/ui-library/sgdf-meeting-table.js";
import { type Meeting } from "@sgdf/client";
import { isOpenMeeting, isNotOpenMeeting } from "~/core/utils/meeting-filter";

const { isLoading, data } = useMeetings();

const onSelectMeeting = async (e: CustomEvent) => {
  const selectedMeeting = e.detail as Meeting;
  await navigateTo(RouteUtils.getMeetingHome(selectedMeeting.id));
};
</script>
